module.exports = __webpack_public_path__ + "media/images/ac_templates/201/ter-51f0d7fdcb897d6ad30ace53e599bfe6.jpg";